// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"_9-z"};